import {PowderguideAuthentication} from "./powderguide-authentication";
import {PowderguideApi, PowderguideApiCacheDecorator, PowderguideApiInterface} from "./powderguide-api";
import {PowderguideApiTokenStorage} from "./powderguide-api-token-storage";
import {PowderguideComments} from "./powderguide-comments";
import {PowderguideRegistration} from "./powderguide-registration";
import {PowderguidePasswordReset} from "./powderguide-password-reset";
import { PowderguideArticles } from './powderguide-articles'
import { PowderguideEvents } from './powderguide-events'
import { PowderguideConditionsReports } from './powderguide-conditions-reports'
import { DateFormatter } from './date-formatter'

interface PowderguideParts {
    tokenStorage: PowderguideApiTokenStorage,
    powderguideApi: PowderguideApiInterface,
    powderguideAuthentication: PowderguideAuthentication,
    powderguideComments: PowderguideComments,
    powderguideRegistration: PowderguideRegistration,
    powderguidePasswordReset: PowderguidePasswordReset,
    powderguideArticles: PowderguideArticles,
    powderguideEvents: PowderguideEvents,
    powderguideConditionsReports: PowderguideConditionsReports,
    dateFormatter: DateFormatter,
}

export function initializePowderguide(Alpine: any): PowderguideParts {
    const cacheElement = document.querySelector('meta[name="powderguide-api-cache"]');
    const cache = cacheElement ? parseInt(cacheElement.getAttribute('content').trim()) : 0;
    const cacheBustElement = document.querySelector('meta[name="powderguide-api-cache-bust"]');
    const cacheBust = cacheBustElement ? cacheBustElement.getAttribute('content').trim() : null;
    const commentUuidElement = document.querySelector('meta[name="powderguide-comment-uuid"]');
    const commentUuid = commentUuidElement ? commentUuidElement.getAttribute('content').trim() : null;
    const commentTargetElement = document.querySelector('meta[name="powderguide-comment-target"]');
    const commentTarget = commentTargetElement ? commentTargetElement.getAttribute('content').trim() : null;
    const lang = document.querySelector('html').getAttribute('lang');

    const tokenStorage = new PowderguideApiTokenStorage();
    let powderguideApi: PowderguideApiInterface = new PowderguideApi(tokenStorage, lang);

    if (cache > 0) {
        powderguideApi = new PowderguideApiCacheDecorator(
            powderguideApi,
            tokenStorage,
            cache,
            cacheBust
        );
    }
    const powderguideAuthentication = new PowderguideAuthentication(
        powderguideApi
    );

    const powderguideComments = new PowderguideComments(
        powderguideApi,
        powderguideAuthentication,
        commentTarget as 'entry'|'conditions_report',
        commentUuid,
    );

    const powderguideRegistration = new PowderguideRegistration(
        powderguideApi,
        (new URLSearchParams(window.location.search)).get('registration_token')
    )

    const powderguidePasswordReset = new PowderguidePasswordReset(
        powderguideApi,
        (new URLSearchParams(window.location.search)).get('password_reset_token')
    )

    const powderguideArticles = new PowderguideArticles(powderguideApi, Alpine);
    const powderguideEvents = new PowderguideEvents(powderguideApi, Alpine);
    const powderguideConditionsReports = new PowderguideConditionsReports(powderguideApi, lang, Alpine);
    const dateFormatter = new DateFormatter(lang);

    return {
        tokenStorage,
        powderguideApi,
        powderguideAuthentication,
        powderguideComments,
        powderguideRegistration,
        powderguidePasswordReset,
        powderguideArticles,
        powderguideEvents,
        powderguideConditionsReports,
        dateFormatter,
    };
}

export async function killOldServiceWorkers(): Promise<void> {
    if (!navigator.serviceWorker || !navigator.serviceWorker.getRegistrations) {
        return;
    }

    const registrations = await navigator.serviceWorker.getRegistrations()
    for (const registration of registrations) {
        if (registration.scope.indexOf('_iframe') !== -1) {
            continue;
        }

        await registration.unregister()
    }
}
